import { Avatar, Box, IconButton, ListItemIcon, Menu, MenuItem, Tooltip } from '@mui/material';
import { useTheme } from "@emotion/react";
import { useAuth } from '../../../utils/AuthContext';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import PersonAdd from '@mui/icons-material/PersonAdd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from "react";
import { BreadCrumbData } from '../../seperator/Seperator.types';

type State = {
    breadcrumbData?: BreadCrumbData[]
}

function User() {

    const theme = useTheme();
    const { user, logoutUser } = useAuth();
    const { state } = useLocation() as { state: State }; // state data from another page
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    function navigateTo(path: string): void {

        const breadcrumbData = [
            
            ...state?.breadcrumbData?.map((bread, index)=> (state.breadcrumbData!.length -1 === index? {...bread, state } :  bread )) ?? [],
            {
                name: "הגדרות",
            }
        ];

        console.log("navigateTo breadcrumbData", breadcrumbData);

        navigate(path, {
            replace: true,
            state: {
                ...state,
                breadcrumbData
            }
        });
    }


    return (
        <div>
            {/* <span>{user?.first_name} {user?.last_name} {user?.email}</span>
            <IconButton onClick={logoutUser}  sx={{ color: theme.colors.main_color }}>
                <LogoutIcon />
            </IconButton> */}
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Tooltip title={user?.first_name + " " + user?.last_name}>
                <IconButton
                    onClick={handleClick}
                    size="small"
                    sx={{ ml: 2 }}
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                >
                    <Avatar sx={{ width: 32, height: 32 }}>{user?.first_name.charAt(0)}</Avatar>
                </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                slotProps={{
                paper: {
                    elevation: 0,
                    sx: {
                    color: theme.colors.main_color,
                    background: theme.colors.section_color,
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                    },
                    '&::before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        left: 14,
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                    },
                    },
                },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                {/* <MenuItem onClick={handleClose}>
                    <Avatar /> Profile
                </MenuItem>
                <MenuItem onClick={handleClose}>
                    <Avatar /> My account
                </MenuItem>
                <Divider /> */}
                {user?.role === "admin" && (
                    <MenuItem onClick={handleClose}>
                        <ListItemIcon>
                            <PersonAdd sx={{ color: theme.colors.main_color }} fontSize="small" />
                        </ListItemIcon>
                        הוספת משתמש
                    </MenuItem>
                )}
                
                <MenuItem onClick={()=>navigateTo("/settings")}>
                    <ListItemIcon>
                        <Settings sx={{ color: theme.colors.main_color }} fontSize="small" />
                    </ListItemIcon>
                    הגדרות
                </MenuItem>
                <MenuItem onClick={logoutUser}>
                    <ListItemIcon>
                        <Logout sx={{ color: theme.colors.main_color }} fontSize="small" />
                    </ListItemIcon>
                    התנתק
                </MenuItem>
            </Menu>
        </div>
    )
}

export default User